<template>
  <div>
    <event-list />
  </div>
</template>

<script>
  import EventList from '@/components/recherche/savedListsV2/RechercheList.vue'

  export default {
    components: {
      EventList
    }
  }
</script>
